exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-info__row {\n    margin: 10px;\n    border-bottom: 1px solid #c1c1c1;\n    padding: 5px;\n    font-size: 1.2em;\n}\n.client-info__field {\n    min-width: 180px;\n    display: inline-block;\n    font-weight: bold;\n    margin-right: 5px;\n}\n.client-info__field::after {\n    content: ':';\n    display: block;\n    float: right;\n}\n.page-header {\n    margin: 20px 0;\n    text-align: center;\n    border: none;\n    font-size: 3em;\n    font-weight: bold;\n}\n.page-header a {\n    font-weight: bold;\n}\n\n@media screen and (max-width: 767px) {\n    .client-info__field {\n        width: 100%;\n    }\n    .client-info__field::after {\n        display: none;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/clients/client/client.component.css
// module id = ../../../../../angular/app/components/clients/client/client.component.css
// module chunks = 1